import { render, staticRenderFns } from "./replyForm.vue?vue&type=template&id=4579d071&scoped=true"
import script from "./replyForm.vue?vue&type=script&lang=js"
export * from "./replyForm.vue?vue&type=script&lang=js"
import style0 from "./replyForm.vue?vue&type=style&index=0&id=4579d071&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4579d071",
  null
  
)

export default component.exports